export const FETCH_INCIDENTS_BY_STATUS = 'FETCH_INCIDENTS_BY_STATUS'
export const FETCH_INCIDENTS_BY_ID = 'FETCH_INCIDENTS_BY_ID'
export const CLEAR_INCIDENTS_BY_STATUS = 'CLEAR_INCIDENTS_BY_STATUS'
export const FETCH_LOADS_FOR_INCIDENT = 'FETCH_LOADS_FOR_INCIDENT'
